import type { TrackDto, TrackSessionDto } from '../api/apiTypes'
import type { Lap } from '../domain/lap/Lap'
import type { TelemetryDiagnostics } from '../domain/telemetry/processed/TelemetryDiagnostics'
import { processTrackSessionWithTrackDto } from '../processors/pipeline'
import type {
  DataQualityMetrics,
  StageExecutionInfo,
} from '../processors/pipeline/ProcessingPipeline'

export interface SessionLaps {
  laps: Lap[]
  stages: StageExecutionInfo[]
  dataQuality: DataQualityMetrics
  diagnostics: TelemetryDiagnostics | null
}

export async function processSessionLaps(
  sessionDto: TrackSessionDto,
  trackDto: TrackDto
): Promise<SessionLaps> {
  const hasFinishLine = trackDto.finishLine && trackDto.finishLine.length >= 1
  const result = await processTrackSessionWithTrackDto(
    sessionDto,
    trackDto,
    undefined,
    hasFinishLine ? { skipLapStages: true } : undefined
  )
  const trackSession = result.trackSession
  if (hasFinishLine) {
    trackSession.applyStartFinishForSession(
      0,
      trackDto.finishLine.map((c) => ({
        latitude: c.latitude,
        longitude: c.longitude,
      }))
    )
  }
  const { stages, dataQuality } = result.processingMetadata
  const diagnostics = trackSession.processedTelemetry.diagnostics ?? null
  return { laps: trackSession.laps, stages, dataQuality, diagnostics }
}
